import React from 'react';
import bemCn from 'bem-cn';
import { BLOG_TYPES } from '../../consts/blog-system.consts';
import { RouteFormatter } from '../../routes';
import PictureSet from '../picture-set';
import SvgPromoFlag from 'src/assets/svg/SvgPromoFlag.svg';
import SvgCalendar from 'src/assets/svg/SvgCalendar.svg';

const b = bemCn('sniff-blog-post');

export const BlogSubDetail = ({ blogPost, updatedAt, noMargin, type }) => {
    if (!blogPost?.author) {
        return '';
    }

    return (
        <div className={b('sub-detail').mix(noMargin ? 'mb-0' : '')}>
            <a href={RouteFormatter.blogAuthor({ slug: blogPost.author.slug })} className={b('sub-detail_author')}>
                <PictureSet imgs={blogPost.author.photo} isAvatar width={64} height={64} alt={blogPost.author.name + ' photo'} />
                <p className="snif-s1 snif-p-pc snif-medium">{blogPost.author.name}</p>
            </a>
            <div className={b('sub-detail_published')}>
                <SvgCalendar className="me-2" />
                <p className="snif-s1 snif-p-pc">{updatedAt}</p>
            </div>
            <a href={BLOG_TYPES[type].slug} className={b('sub-detail_tag')}>
                <SvgPromoFlag className="text-deep me-1" width={20} height={20} />
                <p className="snif-s1">{BLOG_TYPES[type].name}</p>
            </a>
        </div>
    );
};
